<template>
  <div>
    <div class="d-flex flex-column flex-md-row my-5 align-center">
      <div class="d-flex flex-column">
        <div class="font-weight-bold">
          Cursos
        </div>
        <div class="text-body-2 text--secondary mt-1">
          Esses são os cursos que poderão realizar a avaliação
        </div>
      </div>
      <v-spacer />
      <v-btn
        color="primary"
        text
        :disabled="exam.is_published"
        @click="openNewExamTargetsDialog"
      >
        <v-icon
          small
          left
        >
          mdi-plus
        </v-icon> Adicionar Curso
      </v-btn>
    </div>
    <v-simple-table
      fixed-header
    >
      <v-progress-linear
        v-if="loading"
        color="amber"
        indeterminate
      />
      <div
        v-else
        class="mr-5 ml-5"
      >
        <v-data-table
          :headers="headers"
          :items="targets"
          :items-per-page="10"
          item-key="id"
          no-data-text="Nenhum curso cadastrado ainda"
        >
          <template #item.name="{ item }">
            {{ item.name }}
          </template>
          <template #item.education_stage="{ item }">
            {{ item.education_stage.short_name }}
          </template>
          <template #item.education_system="{ item }">
            {{ item.education_system.short_name }}
          </template>
          <template #item.created_at="{ item }">
            <v-btn
              class="mx-1"
              outlined
              small
              fab
              color="primary"
              :disabled="exam.is_published"
              @click="deleteExamTargets(item.id)"
            >
              <v-icon>mdi-delete</v-icon>
            </v-btn>
          </template>
        </v-data-table>
      </div>
    </v-simple-table>
  </div>
</template>

<script>
import handlesServerValidation from '@/mixins/handles-server-validation.js'
import NewExamTargetsDialog from './NewExamTargetsDialog.vue'

export default {

  mixins: [
    handlesServerValidation
  ],

  props: {
    exam: { type: Object, required: true },
    loading: { type: Boolean, default: false }
  },

  data () {
    return {
      targets: [],
      headers: [
        {
          text: 'ID',
          align: 'start',
          value: 'id'
        },
        {
          text: 'Curso',
          align: 'start',
          value: 'name'
        },
        {
          text: 'Segmento',
          align: 'start',
          value: 'education_stage'
        },
        {
          text: 'Sistema',
          align: 'start',
          value: 'education_system'
        },
        {
          text: 'Ações',
          align: 'center',
          value: 'created_at'
        }
      ]
    }
  },
  computed: {
  },
  watch: {
  },
  mounted () {
    this.targets = this.exam.grades
  },
  methods: {
    async listExamTargets () {
      try {
        this.targets = await this.$api.listExamTargets(this.exam.id)
      } catch (e) {
        this.$store.dispatch('setSnackBar', { text: 'Erro ao tentar obter cursos.', color: 'red' })
        this.getErrors(e)
      }
    },
    openNewExamTargetsDialog () {
      this.$dialog.custom(NewExamTargetsDialog).show()
        .then(async (gradeId) => {
          if (gradeId) {
            const data = {
              grade_id: gradeId
            }
            try {
              await this.$api.newExamTargets(this.exam.id, data)
              this.$store.dispatch('setSnackBar', { text: 'Curso adicionado com sucesso.' })
              await this.listExamTargets()
            } catch (e) {
              this.$store.dispatch('setSnackBar', { text: 'Erro ao tentar listar cursos.', color: 'red' })
              this.getErrors(e)
            }
          }
        })
    },
    deleteExamTargets (gradeId) {
      this.$dialog.confirm('Remover curso')
        .text('Tem certeza que deseja remover o curso dessa avaliação ?')
        .label('Remover')
        .onConfirm(async () => {
          try {
            await this.$api.deleteExamTargets(this.exam.id, gradeId)
            this.$store.dispatch('setSnackBar', { text: 'Curso removido com sucesso.' })
            await this.listExamTargets()
          } catch (e) {
            this.$store.dispatch('setSnackBar', { text: 'Erro ao tentar remover curso.', color: 'red' })
            this.getErrors(e)
          }
        })
        .show()
    }
  }
}
</script>
